import { useQuery } from '@tanstack/react-query';

import { currentAccountService } from '../services/currentAccount.service';

export const useCurrentAccountTaxpayerStats = () => {
  return useQuery({
    queryKey: ['current-account-stats'],
    queryFn: () => currentAccountService.getTaxpayerStats()
  });
};
